<template>
  <div>
    <img
      :src="filterImageSrc"
      :class="{
        'cursor-pointer': true,
      }"
      title="Open Modal"
      @click="showModal"
    />
    <!-- The Modal -->
    <div
      v-if="modalDisplay"
      data-testid="modal"
      :class="{
        modal: true,
      }"
    >
      <div
        :class="{
          'modal-content relative rounded-14px bg-www-color-neutral-off-white': true,
        }"
      >
        <div
          :class="{
            'relative rounded-t-14px bg-www-color-white pb-4 pt-5': true,
          }"
        >
          <span
            :class="{
              'close absolute left-5 top-3 cursor-pointer text-28px text-www-color-neutral-medium-dark': true,
            }"
            @click="closeModal"
            >&times;</span
          >
          <div class="text-center text-lg text-www-color-neutral-medium-dark">
            {{ filterTopicsBy }}
          </div>
        </div>
        <div
          :class="{
            'content-wrapper overflow-y-auto px-12 py-9': true,
          }"
        >
          <slot />
        </div>
        <div class="flex items-center justify-between bg-www-color-white px-12 py-5">
          <button
            :class="{
              'cursor-pointer text-sm text-www-color-neutral-medium-dark underline': true,
            }"
            @click="clearAllFilters"
          >
            {{ clearAll }}
          </button>
          <a
            :class="{
              'cursor-pointer bg-www-color-accent-orange-light px-22px py-14px text-center text-[11px] font-medium uppercase leading-4 text-www-color-white underline': true,
            }"
            @click.prevent="closeModal"
            >{{ showResults }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
const props = defineProps({
  pillBarPills: {
    type: Object as PropType<Array<TaxonomyPill>>,
    required: true,
  },
  clearAll: {
    type: String,
    required: true,
  },
  showResults: {
    type: String,
    required: true,
  },
  filterTopicsBy: {
    type: String,
    required: true,
  },
});
const modalDisplay = ref(false);
const showModal = () => {
  modalDisplay.value = true;
};
const closeModal = () => (modalDisplay.value = false);
const clearAllFilters = () => {
  props.pillBarPills.forEach((pill) => {
    emit('taxonomyChange', {
      id: pill.id,
      isChecked: false,
      forceScroll: true,
      slug: pill.slug,
    });
  });
};

const emit = defineEmits<{
  (_evt: 'taxonomyChange', _payload: TaxonomyChangedPayload): void;
}>();
const { $staticImages } = useNuxtApp();
const filterImageSrc = $staticImages['filter-cta'];
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  z-index: 30;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}
.modal-content {
  margin: 18% auto;
  max-width: 726px;
  @media (max-width: 767px) {
    max-width: 353px;
  }
}
</style>
